import { useState, useEffect } from "react";
import AddToCartAnimation from "./AddToCartAnimation";
import { useRef } from "react";
import { getStorageJSON } from "../../../utils/helpers";
export default function FoodCard({ item }) {
    const [qty, setQty] = useState(0);
    const [selectedSize, setSelectedSize] = useState("1000"); // 🔥 default best value
    const [wishlisted, setWishlisted] = useState(false);
    const [animateCart, setAnimateCart] = useState(false);
    const [showQuickView, setShowQuickView] = useState(false);
    const imgRef = useRef();
    // 🔥 GET PRICE FROM FIRESTORE (FIXED)
    const getPrice = () => {
        if (!item.prices) return 0;
        return item.prices[Number(selectedSize)] || 0;
    };

    // 🔥 SYNC CART
    useEffect(() => {
        const cart = getStorageJSON("cart", []);

        const existing = cart.find(
            c => c.id === item.id && c.size === selectedSize
        );

        if (existing) setQty(existing.qty);
        else setQty(0);
    }, [selectedSize, item.id]);

    useEffect(() => {
        const wishlist = getStorageJSON("wishlist", []);
        setWishlisted(wishlist.some((w) => w.id === item.id));
    }, [item.id]);

    // 🔥 UPDATE CART
    const updateCart = (newQty) => {
        let cart = getStorageJSON("cart", []);

        const index = cart.findIndex(
            c => c.id === item.id && c.size === selectedSize
        );

        if (index !== -1) {
            if (newQty > 0) {
                cart[index].qty = newQty;
            } else {
                cart.splice(index, 1);
            }
        } else if (newQty > 0) {
            cart.push({
                id: item.id,
                name: item.name,
                size: selectedSize,
                price: getPrice(),
                qty: newQty
            });
        }

        localStorage.setItem("cart", JSON.stringify(cart));
        window.dispatchEvent(new Event("cart-updated"));
    };

    // ❤️ WISHLIST
    const toggleWishlist = () => {
        let wishlist = getStorageJSON("wishlist", []);

        if (wishlisted) {
            wishlist = wishlist.filter(w => w.id !== item.id);
        } else {
            wishlist.push(item);
        }

        setWishlisted(!wishlisted);
        localStorage.setItem("wishlist", JSON.stringify(wishlist));
        window.dispatchEvent(new Event("wishlist-updated"));
    };

    const handleQuickAdd = () => {
        setQty(1);
        updateCart(1);
        setAnimateCart(true);
        setShowQuickView(false);
    };

    const sizeOptions = ["250", "500", "1000"];
    const currentDescription = item.description || item.details || item.note || "Freshly prepared and packed with care.";
    const currentCategory = item.category || item.type || "Special";
    const currentServes = item.serves || item.serving || item.packSize || (selectedSize === "1000" ? "Best for family sharing" : "Perfect for individual snacking");
    const currentPrice = getPrice();

    return (
        <>
        <div className="food-card-compact">

            {/* ❤️ WISHLIST */}
            <div
                className={`wishlist ${wishlisted ? "active" : ""}`}
                onClick={toggleWishlist}
            >
                ♥
            </div>

            {/* 🏷 BEST VALUE */}
            {selectedSize === "1000" && (
                <div className="best-badge">Best Value 🔥</div>
            )}

            {/* IMAGE */}
            <div className="card-img" ref={imgRef}>
                <button
                    type="button"
                    className="card-image-button"
                    onClick={() => setShowQuickView(true)}
                    aria-label={`Open details for ${item.name}`}
                >
                    <img src={item.image} alt={item.name} />
                </button>
            </div>

            {/* BODY */}
            <div className="card-body">

                <h4>{item.name}</h4>

                {/* SIZE */}
                <div className="size-mini">
                    {sizeOptions.map(size => (
                        <span
                            key={size}
                            className={selectedSize === size ? "active" : ""}
                            onClick={() => setSelectedSize(size)}
                        >
                            {size === "1000" ? "1kg" : size + "g"}
                        </span>
                    ))}
                </div>

                {/* PRICE */}
                <div className="price">
                    ₹{getPrice()}
                </div>

                {/* ADD / QTY */}
                {qty === 0 ? (
                    <button
                        className="add-btn big"
                        onClick={() => {
                            setQty(1);
                            updateCart(1);
                            setAnimateCart(true);
                        }}
                    >
                        Add to Cart
                    </button>
                ) : (
                    <div className="qty-control">
                        <button onClick={() => {
                            setQty(qty - 1);
                            updateCart(qty - 1);
                        }}>−</button>

                        <span>{qty}</span>

                        <button onClick={() => {
                            setQty(qty + 1);
                            updateCart(qty + 1);
                        }}>+</button>
                    </div>

                )}

            </div>

            {animateCart && (
                <AddToCartAnimation
                    image={item.image}
                    start={{
                        x: imgRef.current.getBoundingClientRect().left,
                        y: imgRef.current.getBoundingClientRect().top
                    }}
                    end={{
                        x: window.innerWidth - 80, // cart icon position
                        y: 20
                    }}
                    onDone={() => setAnimateCart(false)}
                />
            )}
        </div>

        {showQuickView && (
            <div className="quick-view-overlay" onClick={() => setShowQuickView(false)}>
                <div className="quick-view-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={`${item.name} details`}>
                    <button
                        type="button"
                        className="quick-view-close"
                        onClick={() => setShowQuickView(false)}
                        aria-label="Close quick view"
                    >
                        ×
                    </button>

                    <div className="quick-view-media">
                        <img src={item.image} alt={item.name} />
                        {selectedSize === "1000" && <span className="best-badge quick-view-badge">Best Value 🔥</span>}
                        <div className="quick-view-features" aria-hidden>
                            <div className="feat">
                                <div className="icon">🌿</div>
                                <div>Freshly Made</div>
                            </div>
                            <div className="feat">
                                <div className="icon">🛡️</div>
                                <div>Hygienically Packed</div>
                            </div>
                            <div className="feat">
                                <div className="icon">🚫</div>
                                <div>No Artificial Preservatives</div>
                            </div>
                            <div className="feat">
                                <div className="icon">💚</div>
                                <div>Loved by Families</div>
                            </div>
                        </div>
                    </div>

                    <div className="quick-view-body">
                        <div className="quick-view-topline">
                            <p className="quick-view-category">{currentCategory}</p>
                            <span className="quick-view-freshness">Fresh</span>
                        </div>

                        <h3>{item.name}</h3>

                        <div className="quick-view-price-block">
                            <div className="quick-view-price-row">
                                <div className="price-left">
                                    <strong>₹{currentPrice}</strong>
                                    <div className="price-unit">for {selectedSize === "1000" ? "1 kg" : `${selectedSize} g`}</div>
                                </div>

                                <div className="quick-view-price-card">
                                    <div className="quick-view-selects">
                                        <div className="select-col">
                                            <label>SIZE</label>
                                            <div className="select-value">{selectedSize === "1000" ? "1 kg" : `${selectedSize}g`}</div>
                                        </div>
                                        <div className="select-col">
                                            <label>SERVES / USE</label>
                                            <div className="select-value">{currentServes}</div>
                                        </div>
                                    </div>

                                    <div className="chip-row">
                                        {sizeOptions.map((size) => (
                                            <button
                                                key={size}
                                                type="button"
                                                className={`chip ${selectedSize === size ? "active" : ""}`}
                                                onClick={() => setSelectedSize(size)}
                                            >
                                                {size === "1000" ? "1 kg" : `${size}g`}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p className="quick-view-description">{currentDescription}</p>

                        <div className="quick-view-actions">
                            <div className="quick-view-action-row">
                                <button
                                    type="button"
                                    className="quick-view-add-btn"
                                    onClick={handleQuickAdd}
                                    style={{
                                        background: "linear-gradient(135deg, #ff8c00, #ff9f1a)",
                                        color: "#ffffff",
                                        border: "none",
                                        boxShadow: "0 12px 28px rgba(255, 139, 0, 0.2)",
                                        WebkitAppearance: "none",
                                        appearance: "none"
                                    }}
                                >
                                    {qty > 0 ? "Add More" : "Add to Cart"}
                                </button>

                                <div className="qty-control quick-view-qty">
                                    <button onClick={() => {
                                        const nextQty = Math.max(0, qty - 1);
                                        setQty(nextQty);
                                        updateCart(nextQty);
                                    }}>−</button>

                                    <span>{qty}</span>

                                    <button onClick={() => {
                                        const nextQty = qty + 1;
                                        setQty(nextQty);
                                        updateCart(nextQty);
                                    }}>+</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}
        </>
    );
}